<!--
 * @Author: your name
 * @Date: 2020-10-19 14:26:35
 * @LastEditTime: 2021-01-16 14:51:16
 * @LastEditors: ezhizao 庄德政
 * @Description: tab的右键菜单
 * @FilePath: \theme3\src\components\ezz-sidemenu\sidemenu.vue
-->
<template>
  <ul class="context-menus" :style="contextMenuStyle" @mouseover="onContextMenuStatus=true" @mouseout="onContextMenuStatus=false">
    <li v-if="contextMenuTab.name !== 'dashboard'" @click="handlerRemoveTabs('current')">关闭当前</li>
    <li v-if="$store.state.tabs.length > 2" @click="handlerRemoveTabs('others')">关闭其它</li>
    <li v-if="(contextMenuTab.index < $store.state.tabs.length - 1)" @click="handlerRemoveTabs('right')">关闭到右侧</li>
    <li v-if="$store.state.tabs.length > 1" @click="handlerRemoveTabs('all')">全部关闭</li>
  </ul>
</template>
<style>
  ul.context-menus {
    display: none;
    position: fixed;
    top: 100px;
    left: 230px;
    width: 150px;
    padding: 10px 0;
    list-style: none;
    background: #fff;
    box-shadow: 0px 0px 3px 1px #999;
    border-radius: 3px;
    z-index: 9999;
  }
  ul.context-menus li {
    padding: 10px 0;
    border-bottom: 1px dotted #999;
    cursor: pointer;
  }
  ul.context-menus li:last-child {
    border-bottom: none;
  }
  ul.context-menus li:hover{
    background: #F59400;
    color: #fff;
  }
</style>
<script>
export default {
  name: 'ContextMenu',
  props: {
    contextMenuTab: {
      type: Object,
      default: () => ({
        index: 0,
        id: '',
        title: '',
        name: '',
        changedName: '',
        router: ''
      })
    },
    contextMenuPosition: {
      type: Object,
      default: () => ({
        x: '0px',
        y: '0px'
      })
    },
    // 需要一个属性，记录父组件传递的菜单数据
    rawMenus: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      // 鼠标是否在右键菜单上
      onContextMenuStatus: false,
      display: 'none'
    }
  },
  computed: {
    // 通过计算属性，可以实施更新，组件的状态
    // 如果通过组件中的方法，修改属性值的方式，则不会马上达到效果
    // 只有下次再调用方法的时候，才会调用上次修改的结果，效果不是实时的。
    contextMenuStyle () {
      const _this = this
      return {
        display: _this.display,
        top: _this.contextMenuPosition.y,
        left: _this.contextMenuPosition.x
      }
    }
  },
  methods: {
    handlerCheckContextMenuStatus: function () {
      // 如果鼠标在右键菜单上，则当前点击的tab，失去焦点时，不关闭右键菜单
      // 否则，则关闭右键菜单
      if (!this.onContextMenuStatus) {
        this.handlerHide()
      }
    },
    handlerShow: function () {
      const tabs = this.$store.state.tabs.filter(tab => tab.name !== 'dashboard')
      this.display = tabs.length > 0 ? 'block' : 'none'
    },
    handlerHide: function () {
      this.display = 'none'
    },
    handlerRemoveTabs: function (_type) {
      const _this = this
      let _tabs = _this.$store.state.tabs
      let _activeTabName = _this.$store.state.activeTabName
      let _activeMenuId = '0'
      // 如果当前激活的tab标签的name，与要删除的标签name相同，
      // 则需要根据当前删除的标签的下标，向后或向前获取新的标签对象
      // 根据新的标签对象的路由名称，实现路由跳转
      const _tabName = _this.contextMenuTab.name
      let _newTabs = []
      switch (_type) {
        // 关闭当前
        case 'current':
          _newTabs = _tabs.filter(tab => tab.name !== _tabName)
          // 如果当前激活的tab页的name，等于当前要删除的tab的name
          if (_activeTabName === _tabName) {
            _tabs.forEach((tab, index) => {
              if (tab.name === _tabName) {
                let nextTab = _tabs[index + 1] || _tabs[index - 1]
                if (nextTab) {
                  _activeTabName = nextTab.name
                  _activeMenuId = nextTab.id
                  _this.$router.replace({
                    name: nextTab.changedName
                  })
                }
              }
            })
          }
          break
        // 关闭其它或右侧
        case 'others':
        case 'right':
          _newTabs = _type === 'others'
          // 关闭其它
            ? _tabs.filter(tab => tab.name === 'dashboard' || tab.name === _tabName)
          // 关闭右侧
            : _tabs.filter((tab, index) => index <= _this.contextMenuTab.index)

          // 如果当前激活的tab与右键点击的tab不相同，则激活当前右键点击的tab
          if (_activeTabName !== _tabName) {
            _activeTabName = _tabName
            _activeMenuId = _this.contextMenuTab.id
            _this.$router.replace({
              name: _this.contextMenuTab.changedName
            })
          }
          break
        // 关闭全部
        case 'all':
          _newTabs = _tabs.filter(tab => tab.name === 'dashboard')
          if (_activeTabName !== 'dashboard') {
            _activeTabName = 'dashboard'
            _activeMenuId = '10000000000000000'
            _this.$router.replace({
              name: 'dashboard'
            })
          }
          break
      }

      // 过滤后的tab数组，赋值给全局的tab数组对象
      _this.$store.state.tabs = _newTabs

      if (_activeMenuId !== '0') {
        _this.$store.state.activeTabName = _activeTabName
        _this.$store.state.activeMenuId = _activeMenuId
        let _currentMenu = _this.rawMenus.filter(menu => menu.id === _activeMenuId)
        if (_currentMenu.length > 0) {
          let _menu = _currentMenu[0]
          // 设置权限按钮
          _this._privateHandlerSetBtns(_menu)
        }
      }

      // 关闭contextMenu
      this.handlerHide()
    },
    // 设置menu对应的列表按钮，表单按钮，编辑权限和删除权限
    _privateHandlerSetBtns: function (_menu) {
      if (_menu !== null) {
        this.$store.state.currentLBtnList = _menu.list_page_buttons
        this.$store.state.currentFBtnList = _menu.form_page_buttons
        this.$store.state.currentVBtnList = _menu.view_page_buttons
      }

      let _vBtnArr = this.$store.state.currentVBtnList
      this.$store.state.editable = (_vBtnArr.length > 0 ? _vBtnArr[0].edit_able : '否')
      this.$store.state.delable = (_vBtnArr.length > 0 ? _vBtnArr[0].delete_able : '否')
    }
  },
  components: {
  }
}
</script>
